// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.obra-detalhes-wrapper {
    display: flex;
    flex-direction: column;
    min-height: 100vh;
}

.obra-detalhes-page {
    max-width: 1400px;
    margin: 0 auto;
    width: 100%;
}

.status-badge {
    padding: 6px 12px;
    border-radius: 20px;
    font-size: 14px;
    font-weight: 500;
}

.status-badge.planeada {
    background: #e2e8f0;
    color: #475569;
}

.status-badge.em_curso {
    background: #dbeafe;
    color: #1e40af;
}

.status-badge.concluida {
    background: #dcfce7;
    color: #166534;
}

.status-badge.suspensa {
    background: #fee2e2;
    color: #991b1b;
}

.obra-content-grid {
    display: grid;
    grid-template-columns: 350px 1fr;
    gap: 24px;
}

@media (max-width: 900px) {
    .obra-content-grid {
        grid-template-columns: 1fr;
    }
}

.info-card {
    background: white;
    border-radius: 12px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
    padding: 24px;
    margin-bottom: 24px;
}

.info-card h2 {
    font-size: 18px;
    color: #2d3748;
    margin: 0 0 16px 0;
    padding-bottom: 12px;
    border-bottom: 1px solid #edf2f7;
    display: flex;
    align-items: center;
    gap: 8px;
}

.detail-row {
    margin-bottom: 16px;
}

.detail-row label {
    display: block;
    font-size: 13px;
    color: #718096;
    margin-bottom: 4px;
}

.detail-row span {
    display: block;
    font-size: 15px;
    color: #2d3748;
    font-weight: 500;
}

.work-tags {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
}

.work-tag {
    background: #f7fafc;
    border: 1px solid #e2e8f0;
    padding: 4px 10px;
    border-radius: 6px;
    font-size: 13px;
    color: #4a5568;
    display: flex;
    align-items: center;
    gap: 6px;
}

.map-card {
    height: 600px;
    display: flex;
    flex-direction: column;
}

.map-view {
    flex: 1 1;
    border-radius: 8px;
    overflow: hidden;
    border: 1px solid #e2e8f0;
    z-index: 1;
}

.custom-map-icon {
    display: flex;
    justify-content: center;
    align-items: center;
    background: transparent;
    border: none;
}

/* Edit Mode Styles */
.work-tag.active {
    background-color: #ebf8ff;
    border-color: #3182ce;
    color: #2b6cb0;
    font-weight: 600;
}

.work-tag.inactive {
    background-color: #f7fafc;
    border-color: #e2e8f0;
    color: #a0aec0;
    opacity: 0.6;
}

.work-tag.inactive:hover {
    opacity: 1;
    background-color: #edf2f7;
}

.form-control {
    width: 100%;
    box-sizing: border-box;
    padding: 7px 10px;
    border: 1px solid #e2e8f0;
    border-radius: 6px;
    font-size: 14px;
    color: #2d3748;
    background: #fff;
}

.form-control:focus {
    outline: none;
    border-color: #3182ce;
    box-shadow: 0 0 0 3px rgba(49, 130, 206, 0.1);
}

textarea.form-control::placeholder {
    color: #a0aec0;
    font-style: italic;
}`, "",{"version":3,"sources":["webpack://./src/pages/ObraDetalhes.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,WAAW;AACf;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,gCAAgC;IAChC,SAAS;AACb;;AAEA;IACI;QACI,0BAA0B;IAC9B;AACJ;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,yCAAyC;IACzC,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,kBAAkB;IAClB,oBAAoB;IACpB,gCAAgC;IAChC,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,QAAQ;AACZ;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,SAAO;IACP,kBAAkB;IAClB,gBAAgB;IAChB,yBAAyB;IACzB,UAAU;AACd;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;AAChB;;AAEA,qBAAqB;AACrB;IACI,yBAAyB;IACzB,qBAAqB;IACrB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;IACrB,cAAc;IACd,YAAY;AAChB;;AAEA;IACI,UAAU;IACV,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,sBAAsB;IACtB,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,6CAA6C;AACjD;;AAEA;IACI,cAAc;IACd,kBAAkB;AACtB","sourcesContent":[".obra-detalhes-wrapper {\r\n    display: flex;\r\n    flex-direction: column;\r\n    min-height: 100vh;\r\n}\r\n\r\n.obra-detalhes-page {\r\n    max-width: 1400px;\r\n    margin: 0 auto;\r\n    width: 100%;\r\n}\r\n\r\n.status-badge {\r\n    padding: 6px 12px;\r\n    border-radius: 20px;\r\n    font-size: 14px;\r\n    font-weight: 500;\r\n}\r\n\r\n.status-badge.planeada {\r\n    background: #e2e8f0;\r\n    color: #475569;\r\n}\r\n\r\n.status-badge.em_curso {\r\n    background: #dbeafe;\r\n    color: #1e40af;\r\n}\r\n\r\n.status-badge.concluida {\r\n    background: #dcfce7;\r\n    color: #166534;\r\n}\r\n\r\n.status-badge.suspensa {\r\n    background: #fee2e2;\r\n    color: #991b1b;\r\n}\r\n\r\n.obra-content-grid {\r\n    display: grid;\r\n    grid-template-columns: 350px 1fr;\r\n    gap: 24px;\r\n}\r\n\r\n@media (max-width: 900px) {\r\n    .obra-content-grid {\r\n        grid-template-columns: 1fr;\r\n    }\r\n}\r\n\r\n.info-card {\r\n    background: white;\r\n    border-radius: 12px;\r\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);\r\n    padding: 24px;\r\n    margin-bottom: 24px;\r\n}\r\n\r\n.info-card h2 {\r\n    font-size: 18px;\r\n    color: #2d3748;\r\n    margin: 0 0 16px 0;\r\n    padding-bottom: 12px;\r\n    border-bottom: 1px solid #edf2f7;\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 8px;\r\n}\r\n\r\n.detail-row {\r\n    margin-bottom: 16px;\r\n}\r\n\r\n.detail-row label {\r\n    display: block;\r\n    font-size: 13px;\r\n    color: #718096;\r\n    margin-bottom: 4px;\r\n}\r\n\r\n.detail-row span {\r\n    display: block;\r\n    font-size: 15px;\r\n    color: #2d3748;\r\n    font-weight: 500;\r\n}\r\n\r\n.work-tags {\r\n    display: flex;\r\n    flex-wrap: wrap;\r\n    gap: 8px;\r\n}\r\n\r\n.work-tag {\r\n    background: #f7fafc;\r\n    border: 1px solid #e2e8f0;\r\n    padding: 4px 10px;\r\n    border-radius: 6px;\r\n    font-size: 13px;\r\n    color: #4a5568;\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 6px;\r\n}\r\n\r\n.map-card {\r\n    height: 600px;\r\n    display: flex;\r\n    flex-direction: column;\r\n}\r\n\r\n.map-view {\r\n    flex: 1;\r\n    border-radius: 8px;\r\n    overflow: hidden;\r\n    border: 1px solid #e2e8f0;\r\n    z-index: 1;\r\n}\r\n\r\n.custom-map-icon {\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    background: transparent;\r\n    border: none;\r\n}\r\n\r\n/* Edit Mode Styles */\r\n.work-tag.active {\r\n    background-color: #ebf8ff;\r\n    border-color: #3182ce;\r\n    color: #2b6cb0;\r\n    font-weight: 600;\r\n}\r\n\r\n.work-tag.inactive {\r\n    background-color: #f7fafc;\r\n    border-color: #e2e8f0;\r\n    color: #a0aec0;\r\n    opacity: 0.6;\r\n}\r\n\r\n.work-tag.inactive:hover {\r\n    opacity: 1;\r\n    background-color: #edf2f7;\r\n}\r\n\r\n.form-control {\r\n    width: 100%;\r\n    box-sizing: border-box;\r\n    padding: 7px 10px;\r\n    border: 1px solid #e2e8f0;\r\n    border-radius: 6px;\r\n    font-size: 14px;\r\n    color: #2d3748;\r\n    background: #fff;\r\n}\r\n\r\n.form-control:focus {\r\n    outline: none;\r\n    border-color: #3182ce;\r\n    box-shadow: 0 0 0 3px rgba(49, 130, 206, 0.1);\r\n}\r\n\r\ntextarea.form-control::placeholder {\r\n    color: #a0aec0;\r\n    font-style: italic;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
